import { Directive, inject } from '@angular/core'
import { ElderEnumTranslationService, ElderSelectComponent } from '@elderbyte/ngx-starter'
import { SortOrder } from './item-sort-spec'

@Directive({
  selector: '[appSortOrderSelect]',
})
export class SortOrderSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const enumTranslationService = inject(ElderEnumTranslationService)
    this.select.placeholder = 'SortOrder.title'
    this.select.displayProperty = 'displayValue'
    this.select.dataSource = enumTranslationService.enumDataSource(SortOrder, 'SortOrder', false)
  }
}
